import React from 'react';
import { Link } from 'react-router-dom';
import { Image, Button, Container, Text, Box /* Link as LinkChakra*/ } from '@chakra-ui/react';
import preval from 'preval.macro';
import Footer from '../components/Footer';

function Darsena() {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';
  const isPromo = process.env.REACT_APP_IS_PROMO === 'true';
  const currentYear = new Date().getFullYear();
  const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

  return (
    <Container my={50} bg='#3c4d5f' centerContent>
      {isDemo && (
        <Text color={'red'} mb={10} fontSize={'4xl'} fontWeight={600}>
          DEMO
        </Text>
      )}

      <Image src={`${imgUrl}/logo.png`} alt='Carnevaldarsena logo' />

      <Text my={5} color={'brand.yellow'} fontSize={'5xl'} fontWeight={600} textAlign='center'>
        🐙 {currentYear} 🐙
      </Text>

      {/* SPONSOR */}
      <Image w={'300px'} src={`${imgUrl}/sponsor/home-eurocolor.jpg`} alt='Sponsor' />

     
      <Text my={10} color={'white'} fontSize={'xl'}>
        Benvenuti alla festa del{' '}
        <Text as='span' color={'brand.green'} fontWeight={600}>
          Carneval
          <Text as='span' color='brand.yellow'>
            darsena
          </Text>
        </Text>
        , edizione {currentYear}!
        <br />
        <br />
        Evita la fila alla cassa e ordina le nostre delizie in tutta comodità con il tuo
        smartphone... al resto pensiamo noi!
      </Text>

      {/* MENU BUTTON */}
      <Button
        borderRadius={'15px'}
        as={Link}
        to='menu'
        mt={37}
        mb={10}
        w={'90%'}
        maxW={'400px'}
        h={'60px'}
        size={'lg'}
        fontSize={'30px'}
      >
        Vai al menù
      </Button>

      {/* SPONSOR BUTTON */}
      <Button
        borderRadius={'15px'}
        as={Link}
        to='sponsor'
        mt={10}
        mb={0}
        w={'90%'}
        maxW={'400px'}
        h={'60px'}
        size={'lg'}
        fontSize={'30px'}
      >
        I nostri sponsor
      </Button>

      {/* SPONSOR */}
      <Image mt={10} w={'400px'} src={`${imgUrl}/sponsor/home-mover.jpg`} alt='Sponsor' />

      {/* SUPPORT BUTTON */}
      <Button
        borderRadius={'15px'}
        as={Link}
        to='support'
        mt={37}
        w={'90%'}
        maxW={'400px'}
        h={'60px'}
        size={'lg'}
        fontSize={'22px'}
      >
        Hai smarrito il tuo ordine?
      </Button>
      {/* PROMO BUTTON */}
      {isPromo && (
        <Button
          as={Link}
          to='promo'
          borderRadius={'15px'}
          mt={30}
          w={'90%'}
          maxW={'400px'}
          h={'60px'}
          size={'lg'}
          fontSize={'22px'}
          textAlign={'center'}
        >
          Segnala un evento <br /> vinci un premio!
        </Button>
      )}

      <Box mt={10}>
        <Footer />
        <Text textAlign='center' fontSize={12} mt={2}>
          {preval`module.exports = new Date().toLocaleString();`}
        </Text>
      </Box>
    </Container>
  );
}

export default Darsena;
